import React from 'react'
import { StatMetricTile, StatMetricsGrid, StatMetricsSection } from 'components/StatMetricTile/StatMetricTile'
import { formatTime } from 'utils/timeUtils'

interface MissionStatsProps {
  coverage: number
  length: number
  time: number
  lengthLabel?: string
  lengthSuffix?: string
  lengthPrecision?: number
  className?: string
}

const MissionStats: React.FC<MissionStatsProps> = ({
  coverage,
  length,
  time,
  lengthLabel = 'Length',
  lengthSuffix = 'm',
  lengthPrecision = 0,
  className,
}) => {
  const formattedLength =
    lengthPrecision > 0
      ? Number(length || 0).toFixed(lengthPrecision)
      : String(Math.round(length || 0))

  return (
    <StatMetricsSection className={className}>
      <StatMetricsGrid columns="1fr 1fr 1fr">
        <StatMetricTile label="Coverage">
          <>
            {Math.round(coverage || 0)}m<sup>2</sup>
          </>
        </StatMetricTile>
        <StatMetricTile label={lengthLabel}>
          <>
            {formattedLength}
            {lengthSuffix === 'm2' ? (
              <>
                m<sup>2</sup>
              </>
            ) : (
              lengthSuffix
            )}
          </>
        </StatMetricTile>
        <StatMetricTile label="Exp Time">{formatTime(time || 0)}</StatMetricTile>
      </StatMetricsGrid>
    </StatMetricsSection>
  )
}

export default MissionStats
